import * as React from 'react';
import * as styles from './styles.css';

import { CSSTransition, SwitchTransition } from 'react-transition-group';

export interface IQuestionSwitchAnim {
  /**
   * questionKey, уникальный идентификатор, отличающий один вопрос от другого
   * необходим для логики работы анимации
   * */
  questionKey: string;

  /** Флаг, означающий, что произошел переход на предыдущий вопрос - анимация будет в другую сторону */
  isSetPrev: boolean;
}

/**
 * Компонент осуществляет анимацию переходов между дочерними компонентами
 * Анимация в виде эффекта перелистывания
 * */
export const QuestionSwitchAnim: React.FC<React.PropsWithChildren<IQuestionSwitchAnim>> = props => {
  const { isSetPrev } = props;

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={props.questionKey}
        classNames={{
          enter: isSetPrev ? styles['animation-enter-prev'] : styles['animation-enter'],
          enterActive: isSetPrev ? styles['animation-enter-prev-active'] : styles['animation-enter-active'],
          exit: styles['animation-exit'],
          exitActive: styles['animation-exit-active'],
        }}
        addEndListener={
          /* istanbul ignore next код из доки, юнит писать бессмысленно */
          (node, done) => {
            node.addEventListener('transitionend', done);
          }
        }
      >
        <div className={styles['container']} data-testid="question-animation">
          {props.children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

QuestionSwitchAnim.displayName = 'QuestionSwitchAnim';
